@if(upsellEnabled()){
<div class='grid grid-cols-1 auto-rows-auto gap-y-4 p-6 !rounded-[5px] w-full' [class]="bannerColor()" [id]="id()+ '-main'" [attr.data-testid]="id()">
    <div class='flex flex-row justify-between'>
        <div class="font-headline-4-strong font-[500]" [id]="id()+ '-title'">
            {{ upsellTitle() }}
        </div>
        <div class=" !justify-self-end">
            <button
                (click)="dispatchUpsellEvent()"
                class="button rounded-full text-white font-button-uppercase bg-dat-blue-500 py-[10px] px-6"
            >
                {{ buttonCta().title }}
            </button>
        </div>
    </div>
    <div class="font-headline-6" [id]="id() + 'subtitle'"> {{ upsellDescription()}}</div>
    @for (point of upsellPoints(); track $index) {
    <div class="flex flex-col gap-y-2" [id]="id() + 'point' + $index">
        <div class="flex flex-row items-center">
            <span class="material-symbols-outlined pr-2">{{point.icon}}</span>
            <div class="font-headline-5 font-[600]" [id]="id() + 'point-title' + $index">{{ point.title }}</div>
        </div>
        <div class="font-headline-6" [id]="id() + 'point-description' + $index">{{ point.description }}</div>
    </div>
    }
</div>
}